import { createApp } from 'vue';
import App from './App.vue';
import './assets/style.less';
import Vue3NativeNotification from 'vue3-native-notification';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { createPinia } from 'pinia';
import {TippyPlugin} from 'tippy.vue';
import i18n from './i18n';
import vue3PhotoPreview from 'vue3-photo-preview';
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import VueApexCharts from "vue3-apexcharts";
import Vue3linkify from "vue-3-linkify";
import VueTelInput from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'

let axios_instance = axios.create({
  headers: {
    'Content-Type': 'application/vnd.api+json',
    'Accept': 'application/vnd.api+json',
  },
});
const pinia = createPinia();
const app = createApp(App);

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        tracingOrigins: ["dashboard.chatpilot.io", /^\//],
      }),
    ],
    tracesSampleRate: 1.0,
    autoSessionTracking: false,
  });
}

app.use(VueAxios, axios_instance);
app.use(Vue3NativeNotification, { requestOnNotify: true });
app.use(pinia);
app.use(TippyPlugin);
app.use(i18n);
app.use(vue3PhotoPreview);
app.use(VueApexCharts);
app.use(VueTelInput);
app.use(Vue3linkify);
app.mount('#app');
